<template>
  <div class="main">
    <div class="left-bar">
      <sub-left-menu :menus="menus" :selectTrace="selectTrace"></sub-left-menu>
    </div>
    <div class="sub-main">
      <breadcrumb :paths="selectTrace"></breadcrumb>
      <div class="article-list">
        <router-link class="article-item" v-for="(article,index) in articles" :key="index" :to="'/article/'+article.articleId">
          <!-- <div class="article-item-image">
            <img :src="article.image" alt="">
          </div> -->
          <div class="article-item-info">
            <div class="article-item-title">{{article.title}}</div>
            <div class="article-item-brief">{{article.brief}}</div>
            <div class="article-item-footer">
              <div class="article-item-date">{{ newsDate(article.addTime) }}</div>
              <div class="article-item-href">详情</div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="load-more" @click="loadMore" v-if="!articleEmpty && articles.length > 0">加载更多...</div>
      <div class="load-more" v-if="articleEmpty && articles.length > 0">已无更多内容</div>
      <div class="load-more" v-if="articleEmpty && articles.length == 0">暂无该内资源</div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/widgets/public/Breadcrumb'
import SubLeftMenu from '@/widgets/public/SubLeftMenu'

import service from '@/utils/service'
import tools from '@/utils/base'
import dateFormatter from '@/utils/date'

export default {
  components: { Breadcrumb, SubLeftMenu },
  data () {
    return {
      classifyTree: [],
      currentNode: [],
      articles: [],
      classifyId: 0,
      articleEmpty: false
    }
  },
  computed: {
    menus () {
      let menus = []
      for (var i in this.classifyTree) {
        let node = this.toMenuItem(this.classifyTree[i])
        if ('children' in this.classifyTree[i]) {
          let menuItem = []
          for (var j in this.classifyTree[i]['children']) {
            menuItem.push(this.toMenuItem(this.classifyTree[i]['children'][j]))
          }
          node['children'] = menuItem
        }
        menus.push(node)
      }
      return menus
    },
    selectTrace () {
      let selectTrace = []
      for (var i in this.currentNode) {
        selectTrace.push(this.toMenuItem(this.currentNode[i]))
      }
      return selectTrace
    }
  },
  created () {
    this.refreshArticleInfo()
  },
  methods: {
    refreshArticleInfo () {
      this.classifyId = tools.getIndex(this.$route.query, 'classifyId', 332)
      this.articles = []
      this.articleEmpty = false
      this.loadPathTrace()
      this.loadMenu()
      this.loadArticles(0)
    },
    loadMenu () {
      let _this = this
      service.get('/article/classifyTree').then(function (response) {
        _this.classifyTree = response
      })
    },
    loadPathTrace () {
      let _this = this
      service.get('/article/getTrace?classifyId=' + this.classifyId).then(function (response) {
        _this.currentNode = response
      })
    },
    loadArticles (offset) {
      let _this = this
      service.get('/article/articleList?classifyId=' + this.classifyId + '&offset=' + offset).then(function (response) {
        _this.articles = _this.articles.concat(response)
        if (response.length < 10) {
          _this.articleEmpty = true
        }
      })
    },
    toDetail (articleId) {
      this.$router.push('/article/' + articleId)
    },
    toMenuItem (node) {
      return {'nodeId': node.nodeId, 'name': node.label, 'url': '/article?classifyId=' + node.nodeId}
    },
    loadMore () {
      let offset = this.articles.length
      this.loadArticles(offset)
    },
    newsDate (dateString) {
      return dateFormatter.toChinese(dateString, '%Y年%M月%D日')
    }
  },
  watch: {
    $route () {
      this.refreshArticleInfo()
    }
  }
}
</script>

<style scoped>
.article-list {
  margin-top: 15px;
}
.article-item {
  margin-bottom: 14px;
  background: #ffffff;
  display: flex;
  height: 200px;
  border:solid 1px #f1f1f1;
  overflow: hidden;
}
.article-item-image {
  width: 240px;
  height: 180px;
}
.article-item-info {
  flex: 1;
  padding: 20px 25px;
  display: flex;
  flex-direction: column;
}
.article-item-title {
   font-size: 19px;
  margin-bottom: 8px;
  color: #333333;
}
.title-header{
  display: inline-block;
  height:100%;
  width:6px;
  background: #018FD7;
}
.article-item-brief {
  flex: 1;
}
.article-item-footer {
  padding: 4px 0;
  height:24px;
  display: flex;
}
.article-item-date {
  margin-right: 15px;
}
.article-item-href {
  color: #abc;
}
.load-more{
  margin: 25px 0 0 0;
  cursor: pointer;
  color:#018FD7;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/article/List.vue